/* @flow */
import React from 'react';

import ActivitiesClassContainer from 'payments/containers/ActivitiesClassContainer.jsx';
import ActivitiesClassViewHeader from 'payments/components/ActivitiesClassViewHeader.jsx';

import styles from './styles/ActivitiesClassView.css';

class ActivitiesClassView extends React.Component {
  static contextTypes = {
    group: React.PropTypes.object.isRequired,
  }

  render() {
    return (
      <div className={styles.this}>
        <ActivitiesClassViewHeader />
        <div className={styles.content}>
          <ActivitiesClassContainer
            data-test="activities-class-container"
            group={this.context.group}
          />
        </div>
      </div>
    );
  }
}

export default ActivitiesClassView;



// WEBPACK FOOTER //
// ./src/groups/components/ActivitiesClassView.jsx